/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDomainAction.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/domain-action";

export class AutogenModelDomainAction<RowType extends ModelRow> extends Endpoint<RowType, RowDomainActionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDomainAction extends ModelRow<RowDomainActionFields> {
	constructor(values?: Partial<RowDomainActionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDomainActionFields {
	associated_class: string;
	caption: string;
	company_id: string;
	fielddomain_id: string;
	sequence: number;
}

